import { render, staticRenderFns } from "./DestinationTable.vue?vue&type=template&id=504af5b0&"
import script from "./DestinationTable.vue?vue&type=script&lang=js&"
export * from "./DestinationTable.vue?vue&type=script&lang=js&"
import style0 from "./DestinationTable.vue?vue&type=style&index=0&id=504af5b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports